<template>
  <section style="height: 100%" class="d-flex align-center">
    <v-container>
      <v-row class="d-flex justify-center">
        <v-col cols="11" md="10" class="pa-0">
          <v-card class="pa-3" color="blur">
            <v-card-text style="color: #eeeeee" class="text-center">
              <h2 class="ma-0">Register</h2>
            </v-card-text>

            <v-card-text class="px-0 pb-0">
              <v-stepper  v-model="stepper" class="blur">
                <v-stepper-header>
                  <v-stepper-step :complete="stepper > 1" :editable="stepper < 3" step="1">Account type</v-stepper-step>
                  <v-divider/>
                  <v-stepper-step :complete="stepper > 2" step="2">Register account</v-stepper-step>
                  <v-divider/>
                  <v-stepper-step step="3">Confirm email</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-list class="text-center" three-line>
                      <v-list-item v-for="(role, idx) in roles" :key="idx" @click="profileType = role.value, stepper = 2">
                        <v-list-item-content>
                          <v-list-item-title v-text="role.label"/>
                          <v-list-item-subtitle v-text="role.description"/>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-form @submit="register">
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                              v-model="first_name"
                              color="success"
                              label="First name"
                              prepend-icon="mdi-face"
                              :error-messages="api_errors['first_name']"
                              type="text"
                              autofocus
                          />
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                              v-model="last_name"
                              color="success"
                              label="Last name"
                              prepend-icon="mdi-face"
                              :error-messages="api_errors['last_name']"
                              type="text"
                          />
                        </v-col>
                      </v-row>

                      <v-text-field label="Email"
                                    v-model="email"
                                    color="success"
                                    prepend-icon="mdi-email"
                                    :error-messages="api_errors['email']"
                                    type="email"
                                    suffix="@gmail.com"
                      />

                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                              v-model="password"
                              color="success"
                              label="Password"
                              prepend-icon="mdi-lock-outline"
                              :error-messages="api_errors['password']"
                              :type="passwordType ? 'password' : 'text'"
                          >
                            <v-icon slot="append" color="success" @click="passwordType = !passwordType">
                              {{ passwordType ? 'mdi-eye' : 'mdi-eye-off' }}
                            </v-icon>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                              v-model="password_confirmation"
                              color="success"
                              label="Password confirmation"
                              prepend-icon="mdi-lock-outline"
                              :error-messages="api_errors['password']"
                              type="password"
                          />
                        </v-col>
                      </v-row>

                      <v-list-item two-line>
                        <v-list-item-action>
                          <v-checkbox v-model="acceptPolicy" color="success" class="mt-0"/>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            I Accept the
                            <a class="success--text" target="_blank" href="https://qltsosce.co.uk/terms-conditions-supply">TERMS & CONDITIONS OF SUPPLY</a> |
                            <a class="success--text" target="_blank" href="https://qltsosce.co.uk/terms-use">TERMS OF USE</a> |
                            <a class="success--text" target="_blank" href="https://qltsosce.co.uk/privacy-policy">PRIVACY POLICY</a> |
                            <a class="success--text" target="_blank" href="https://qltsosce.co.uk/cookie-policy">COOKIE POLICY</a>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-action>
                          <v-checkbox v-model="acceptUseInfo" color="success" class="mt-0"/>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            I do not want to obtain information about similar products and updates
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-action>
                          <v-checkbox v-model="acceptUseData" color="success" class="mt-0"/>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            I ‘Consent’ and agree to the processing of personal data. Please note, that the Consent
                            can be withdrawn at any time via your account Profile / Remove Account*
                          </v-list-item-title>

                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item>
                        <v-list-item-action>
                          <v-checkbox v-model="acceptSharingData" color="success" class="mt-0"/>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            Subject to my subscription for a Study Group, I authorise the sharing of my personal data
                            with OSCEsmart team and other members of the Study Group(s) to the extent required for
                            the provision of the Services.*
                          </v-list-item-title>

                        </v-list-item-content>
                      </v-list-item>

                      <v-divider/>
                      <v-col class="text-center">
                        <v-btn color="primary" @click="stepper = 1">Back</v-btn>
                        <v-btn color="success" type="submit" :loading="loading"
                        :disabled="!acceptPolicy || !acceptUseInfo || !acceptUseData || !acceptSharingData || loading"
                        >Continue</v-btn>
                      </v-col>
                    </v-form>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <v-form @submit="confirmEmail">
                      <v-subheader style="color: #eeeeee">
                        Thanks for signing up on SQEsmart! Before you start using the platform, please confirm your e-mail address so we can verify that you’re really you.
                      </v-subheader>
                      <v-text-field label="Email*"
                                    v-model="email"
                                    color="success"
                                    validate-on-blur
                                    :error-messages="api_errors['email']"
                                    suffix="@gmail.com"
                      />

                      <v-text-field
                          v-model="code"
                          color="success"
                          label="Confirmation code from email*"
                          validate-on-blur
                          :error-messages="api_errors['code']"
                      />

                      <v-col class="text-center">
                        <v-btn color="primary" @click="stepper = 2">Back</v-btn>
                        <v-btn color="success" type="submit" :loading="loading" :disabled="loading">Continue</v-btn>
                      </v-col>
                    </v-form>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  data:() => ({
    activeTab: 2,
    stepper: 1,
    tab_disabled: false,
    roles: [
      {
        label: 'Aspiring Solicitor',
        value: 'aspiringSolicitor',
        description: 'A QLTS/SQE candidate subscribed/willing to subscribe to an OSCEsmart/SQEsmart course taught by Tutoring Solicitors \n',
      },
      {
        label: 'Tutoring Solicitor',
        value: 'tutoringSolicitor',
        description: 'A fee-earning solicitor assisting/willing to assist to run an OSCEsmart/SQEsmart course. A Tutoring Solicitor may also be a barrister willing to assist with litigation/higher rights of audience',
      },
      {
        label: 'Interviewer',
        value: 'interviewer',
        description: 'Either an academic or an actor specially trained/willing to be trained to conduct user interviews for an OSCEsmart/SQEsmart course.',
      },
    ],
    profileType: '',

    user: null,
    experience: [],

    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password_confirmation: '',

    passwordType: true,
    acceptPolicy: false,
    acceptUseInfo: false,
    acceptUseData: false,
    acceptSharingData: false,
    code: '',
    api_errors: [],
    loading: false,
  }),
  methods: {
    ...mapMutations({
      setAuthToken: 'SET_AUTH_TOKEN',
      setAuthUser: 'SET_AUTH_USER',
    }),
    register(e) {
      e.preventDefault()
      this.api_errors = []
      this.loading = true
      this.axios.post('api/register', {
        profile_type: this.profileType,
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email+'@gmail.com',
        password: this.password,
        password_confirmation: this.password_confirmation,
      })
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.tab_disabled = true
            this.stepper = 3
          })
          .catch(errors => {
            this.api_errors = errors.response.data.errors
          })
          .then(() => {this.loading = false})
    },
    confirmEmail(e) {
      e.preventDefault()
      this.api_errors = []
      this.loading = true
      this.axios.post('api/email/verify', { email: this.email+'@gmail.com', code: this.code})
          .then(({data}) => {
            this.setAuthToken(data.data.access_token)
            // this.setAuthUser(data.data.user)
            this.$router.push('/')
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.loading = false})
    }
  }

}
</script>